import $ from 'jquery';

import propertyViewMapService   from 'PropertyViewMapService.js';
import BasePropertyTabView      from 'properties/BasePropertyTabView';
import contentTemplate          from 'properties/attributes-view.ejs';
import listService              from 'ListService';

class AttributesView extends BasePropertyTabView {

    initialize( opts ) {
        this.options = opts || {};

        this.tagName = 'div';
        this.id = '#propMain';
        //this.className = 'propMain';
        this.factoryKey = opts.factoryKey;

        super.initialize(opts);

        this.template = contentTemplate;
        //this.listenTo(this.model, 'change', this.render);

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        return this;
    }

    render(opts) {
        this.factoryKey = this.model.attributes.factoryKey;
        if (opts && opts.factoryKey) {
            this.factoryKey = opts.factoryKey;
        }
        super.render();
        let views;

        if (listService.selectedCount > 1) {
            views = propertyViewMapService.getMultipleSelectedAttributesViews();
            this.model = listService.combineSelectedModels();
        } else {
            views = propertyViewMapService.getAttributeViews(this.factoryKey);
        }

        // Render Property Views
        if (views.size === 0) {
            $('#attributes-section').css('display', 'none');
        } else {
            $('#attributes-section').css('display', '');
            this.renderPropertyViews(views, this.model);
            $('#attributes-section .switch').on('click', function () {
                $(this).find('i').toggleClass('pf-carot-down pf-carot-left');
            });
        }

        return this;
    }
}

export default AttributesView;